export const navigationAction = (param) => {
  return (dispatch) => {
    console.log("11111111params",param)
    dispatch({ type: "SET_NAVIGATION", data: param });
  }
};